import { createAction, createReducer } from '@reduxjs/toolkit';

export interface IProducts {
  products: any[];
}

const INITIAL_STATE: IProducts = {
  products: [],
};

export const getProductsListAction = createAction<Array<IProducts>>(
  '@productsPage/GET_PRODUCTS'
);

const productsReducer = createReducer(INITIAL_STATE, {
  [getProductsListAction.type]: (state, action) => ({
    ...state,
    products: action.payload,
  }),
});

export default productsReducer;
